// Module
var code = "<template>\n  <span class=\"text-danger\" hover-box=\"contents.one-time: IsDirtyExplanation; css-class: scope-isdirty-explanation-hover\"></span>\n</template>";
// Exports
export default code;